import { DataSourceType } from '@/models/dataSource';
import { FC, PropsWithChildren } from 'react';
import { DataSourceTypeCard } from './DataSourceTypeCard';

type DataSourcesTypeCardContainerProps = {
  dataSources: DataSourceType[];
  onCardClick: (source: DataSourceType) => void;
} & PropsWithChildren;

export const DataSourcesTypeCardContainer: FC<DataSourcesTypeCardContainerProps> = ({ dataSources, onCardClick, children }) => {
  return (
    <div className='grid max-w-[58.875rem] grid-cols-1 gap-8 pt-4 md:grid-cols-2 md:gap-8 xl:grid-cols-3'>
      {dataSources?.map((source) => <DataSourceTypeCard key={source.name} dataSourceType={source} onClick={() => onCardClick(source)} />)}
      {children}
    </div>
  );
};
